const MAX_HTML_CHARS = 40_000;

const REMOVED_SELECTORS = [
  'script',
  'style',
  'noscript',
  'iframe',
  'template',
  '[data-help-exclude]',
].join(',');

const PRESERVED_ATTRIBUTES = new Set([
  'href',
  'data-tour',
  'role',
  'aria-label',
  'alt',
  'title',
  'type',
  'value',
  'checked',
  'selected',
  'name',
  'placeholder',
  'for',
  'id',
]);

function sanitizeClonedSubtree(root: Element): void {
  root.querySelectorAll(REMOVED_SELECTORS).forEach((node) => node.remove());

  root.querySelectorAll('input[type="password"]').forEach((node) => node.remove());

  root.querySelectorAll('*').forEach((element) => {
    for (const attribute of Array.from(element.attributes)) {
      if (!PRESERVED_ATTRIBUTES.has(attribute.name)) {
        element.removeAttribute(attribute.name);
      }
    }

    if (element instanceof HTMLInputElement && element.type !== 'password') {
      if (element.value) {
        element.setAttribute('value', element.value);
      }
      if (element.checked) {
        element.setAttribute('checked', 'checked');
      }
    }

    if (element instanceof HTMLTextAreaElement && element.value) {
      element.textContent = element.value;
    }

    if (element instanceof HTMLOptionElement && element.selected) {
      element.setAttribute('selected', 'selected');
    }
  });
}

function truncateHtml(html: string): string {
  if (html.length <= MAX_HTML_CHARS) {
    return html;
  }
  return `${html.slice(0, MAX_HTML_CHARS)}\n… [truncated]`;
}

/**
 * Captures a sanitized snapshot of the main content area for Alex (background only).
 */
export function collectHelpPageContext(): string {
  const root = document.querySelector('[data-help-content-root]');
  const pathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;
  const title = document.title;
  const capturedAt = new Date().toISOString();

  let html = '(No content root found.)';
  if (root) {
    const clone = root.cloneNode(true) as Element;
    sanitizeClonedSubtree(clone);
    html = truncateHtml(clone.innerHTML.trim() || '(Empty content area.)');
  }

  return [
    `Route: ${pathname}${search}${hash}`,
    `Title: ${title}`,
    `Captured at: ${capturedAt}`,
    '',
    '## Content area HTML snapshot',
    html,
  ].join('\n');
}
